export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_deductionType') || '扣款项目',
    field: 'deductionType',
    align: 'center',
    minWidth: 200,
    editRender: {
      name: 'dict-select',
      props: {
        body: { dictType: 'deductionType' },
        url: '/master/common/dict/biz',
        filterable: true,
        clearable: true,
      },
    },
  },
  {
    title: that.$l('item_label_currencyAmount') || '费用金额',
    field: 'currencyAmount',
    align: 'center',
    width: 180,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 99999999999974,
        step: 0.01,
        placeholder: that.$l('form_placeholder_currencyAmount') || '请输入费用金额',
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('item_label_custCode') || '费用客户',
    field: 'custName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'customer' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('item_label_custOrderNo') || '订单编号',
    field: 'custOrderNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'custOrderNo' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_scmName') || '供应商',
    field: 'scmName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'scmName' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('item_label_scmCurrencyAmount') || '供应商扣款金额',
    field: 'scmCurrencyAmount',
    align: 'center',
    width: 180,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 99999999999974,
        step: 0.01,
        placeholder: that.$l('form_placeholder_scmCurrencyAmount') || '请输入供应商扣款金额',
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('item_label_orgDepFullName') || '分摊部门',
    field: 'orgDepFullName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    editRender: { enable: true },
    slots: { edit: 'depCode' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
